import { TextField, TextFieldProps } from "@mui/material";
import Field from "components/Field";

type FormTextFieldProps = {
  name: string;
  required?: boolean;
} & Omit<TextFieldProps, "variant">;

const FormTextField = ({ name, required = false, ...rest }: FormTextFieldProps) => (
  <Field name={name} required={required}>
    {({ input, meta }) => (
      <TextField
        variant="standard"
        fullWidth
        InputLabelProps={{ required }}
        error={meta.error && meta.submitFailed}
        helperText={meta.error && meta.submitFailed && meta.error}
        {...rest}
        {...input}
      />
    )}
  </Field>
);

export default FormTextField;
